class ReadMore extends HTMLElement {
  connectedCallback() {
    this.content = this.querySelector('[data-read-more-content]');
    this.button = this.querySelector('[data-read-more-button]');
    if (!this.content || !this.button) return;

    this.labelMore = this.button.dataset.labelMore;
    this.labelLess = this.button.dataset.labelLess;

    this.button.addEventListener('click', () => this.toggle());

    this.resizeObserver = new ResizeObserver(() => this.update());
    this.resizeObserver.observe(this.content);
    this.update();
  }

  disconnectedCallback() {
    if (this.resizeObserver) this.resizeObserver.disconnect();
  }

  get isExpanded() {
    return this.hasAttribute('expanded');
  }

  toggle() {
    if (this.hasAttribute('animating')) return;

    const startHeight = this.content.getBoundingClientRect().height;
    const willExpand = !this.isExpanded;

    this.toggleAttribute('expanded', willExpand);
    this.button.setAttribute('aria-expanded', String(willExpand));
    this.button.textContent = willExpand ? this.labelLess : this.labelMore;

    // line-clamp can't be animated, so tween an explicit height between the two states.
    const endHeight = willExpand ? this.content.scrollHeight : this.content.clientHeight;
    const duration = parseFloat(getComputedStyle(this.content).transitionDuration);
    if (!duration || startHeight === endHeight) return;

    // Keep the text unclamped while animating so it doesn't snap to four lines.
    this.setAttribute('animating', '');
    this.content.style.height = `${startHeight}px`;
    this.content.getBoundingClientRect();
    this.content.style.height = `${endHeight}px`;

    const onEnd = (event) => {
      if (event.target !== this.content || event.propertyName !== 'height') return;
      this.content.removeEventListener('transitionend', onEnd);
      this.removeAttribute('animating');
      this.content.style.height = '';
    };
    this.content.addEventListener('transitionend', onEnd);
  }

  update() {
    // Only measure while clamped; an expanded block always keeps its toggle.
    if (this.isExpanded || this.hasAttribute('animating')) return;
    const isOverflowing = this.content.scrollHeight - this.content.clientHeight > 1;
    this.toggleAttribute('overflowing', isOverflowing);
  }
}

if (!customElements.get('read-more')) customElements.define('read-more', ReadMore);
